var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88596 18.0141H24.772V21.1188C24.772 21.8783 24.1517 22.4986 23.3922 22.4986L3.26725 22.5001C2.50774 22.5001 1.8874 21.8798 1.8874 21.1203V18.0156L1.88596 18.0141ZM13.7435 11.0349C12.904 9.66987 11.5819 8.63501 10.017 8.16419C9.43959 8.44697 8.79257 8.6054 8.10856 8.6054C7.42307 8.6054 6.7761 8.44699 6.19867 8.16419C3.69951 8.91631 1.82218 11.1075 1.53223 13.7755H12.1151L13.7422 11.035L13.7435 11.0349ZM8.10864 7.88437C10.0985 7.88437 11.7211 6.26172 11.7211 4.27189C11.7211 2.28206 10.0985 0.659424 8.10864 0.659424C6.11881 0.659424 4.49617 2.28206 4.49617 4.27189C4.49617 6.26172 6.11881 7.88437 8.10864 7.88437ZM22.0109 13.7754L25.1659 8.31227H16.2014L12.9561 13.7754H22.0109ZM25.1689 14.4964H1.49065C0.720794 14.4964 0.0915527 15.1256 0.0915527 15.8955V17.2931H26.5677V15.8955C26.5677 15.1256 25.9387 14.4964 25.1689 14.4964Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistration);
export default __webpack_public_path__ + "static/media/registration.6d4b7e272a890788ec0412c76d5835be.svg";
export { ForwardRef as ReactComponent };